export default {

	data() {
		return {
			sort: {
				column: false,
				direction: false,
			},
		};
	},

	methods: {

		sortByColumn(columnName) {
			const sortOptions = ['asc', 'desc', false];

			let direction = -1;
			if (this.sort.column === columnName) {
				direction = sortOptions.indexOf(this.sort.direction);
			}

			direction++;

			if (!sortOptions[ direction ]) {
				columnName = false;
			}

			this.sort = {
				column: columnName,
				direction: sortOptions[ direction ],
			};

		},

		headerColumnClass(field) {
			let classes = ['sortable'];

			if (this.sort.column == field.slug) {
				if (this.sort.direction === 'asc') {
					classes.push('point-up');
				}
			} else {
				classes.push('point-down');
			}

			return classes.join(' ');
		},

	},

};
